
export function validateEmail(email: string): { valid: boolean; reason?: string } {
  // Check if email exists
  if (!email || email.trim() === "") {
    return { valid: false, reason: "Email is required" };
  }

  // Basic email format check with regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { valid: false, reason: "Invalid email format" };
  }

  // Check for disposable email domains (add more as needed)
  const disposableDomains = [
    "tempmail.com", "10minutemail.com", "mailinator.com", 
    "guerrillamail.com", "yopmail.com", "sharklasers.com",
    "throwawaymail.com", "getairmail.com", "temp-mail.org"
  ];
  
  const domain = email.split('@')[1].toLowerCase();
  if (disposableDomains.includes(domain)) {
    return { valid: false, reason: "Disposable email providers are not allowed" };
  }

  return { valid: true };
}
